import { useEffect, useState } from "react";
import { useLazyGetGoalPageQuery } from "../goalsApi";
import { FetchGoalsParams } from "../types";

type DeepLinkState = "idle" | "fetching-page" | "ready" | "error";

interface UseGoalDeepLinkReturn {
  isDeepLinking: boolean;
  deepLinkReady: boolean;
  shouldSkipInitialQuery: boolean;
  shouldPreventReset: boolean;
}

export function useGoalDeepLink(
  highlightGoalId: number | undefined,
  filterParams: FetchGoalsParams,
  setPageSelected: (page: number) => void
): UseGoalDeepLinkReturn {
  const [state, setState] = useState<DeepLinkState>("idle");

  const [fetchGoalPage] = useLazyGetGoalPageQuery();

  useEffect(() => {
    if (!highlightGoalId) {
      setState("idle");
      return;
    }

    setState("fetching-page");

    fetchGoalPage({ goalId: highlightGoalId, params: filterParams })
      .unwrap()
      .then((page) => {
        setPageSelected(page);
        setState("ready");
      })
      .catch(() => {
        setState("error");
      });
  }, [highlightGoalId, fetchGoalPage, filterParams, setPageSelected]);

  const isDeepLinking = state === "fetching-page";
  const deepLinkReady = state === "ready";
  const shouldSkipInitialQuery = !!highlightGoalId && state === "fetching-page";
  const shouldPreventReset =
    !!highlightGoalId && state !== "ready" && state !== "error";

  return {
    isDeepLinking,
    deepLinkReady,
    shouldSkipInitialQuery,
    shouldPreventReset,
  };
}
